import React, { useEffect, useMemo, useState } from "react";
import { useShowModal } from "../../../hooks";
import { Header, Wrapper, CardWrapper } from "./style";
import Button from "../../../components/FormElement/Button";
import { PlusOutlined } from "@ant-design/icons";
import Form from "./Form";
import Pagination from "../../../components/FormElement/Pagination";
import DeleteModal from "../../../components/DeleteModal";
import { useHideModal } from "../../../hooks";
import OurTeamCard from "../../../components/Cards/OurTeamCard";
import Tab from "../../../components/Tab";
import service from "../../../services/ourteam";
import section from "../../../services/section";
import Spinner from "../../../components/Spinner/FullScreen";
import { useShowAlert } from "../../../hooks/useAlerts";

function Dashboard() {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const { error } = useShowAlert();
  const { showBlured } = useShowModal();
  const [departments, setDepartments] = useState([]);
  const { hideModal } = useHideModal();
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const categoryQuery = useMemo(
    () => (selectedCategory ? `&department=${selectedCategory}` : ""),
    [selectedCategory]
  );
  const pageQuery = useMemo(
    () => (pagination.page ? `page=${pagination.page}` : ""),
    [pagination.page]
  );
  const limitQuery = useMemo(
    () => (pagination.limit ? `&limit=${pagination.limit}` : ""),
    [pagination.limit]
  );
  const query = useMemo(
    () => `${pageQuery}${limitQuery}${categoryQuery}`,
    [pageQuery, limitQuery, categoryQuery]
  );

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await service.getAllPaginate(query);
      const finalResult = result?.rows.map((item) => ({
        ...item,
        title: item?.full_name,
      }));
      setData(finalResult);
      setTotal(result?.count);
    } catch (err) {
      console.log(err);
      error(
        "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [query]);

  useEffect(() => {
    setLoading(true);
    section
      .getAll()
      .then((resp) => {
        setDepartments(resp);
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChangePagination = (pageNumber) => {
    setPagination((prev) => ({ ...prev, page: pageNumber }));
  };
  const handleDelete = (id) => {
    if (id) {
      showBlured({
        title: "",
        maxWidth: "400px",
        maxHeight: "500px",
        withHeader: false,
        body: () => <DeleteModal onClick={() => handleDel(id)} />,
      });
    }
  };

  const handleDel = (id) => {
    setLoading(true);
    service
      .delete(id)
      .then(() => {
        fetchData();
        hideModal();
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const options = useMemo(
    () => [
      { key: "", label: "Barchasi" },
      ...departments.map((department) => ({
        key: department.id.toString(),
        label: department.title,
      })),
    ],
    [departments]
  );

  const changeTab = (key) => {
    setPagination((prev) => ({ ...prev, page: 1 }));
    setSelectedCategory(key);
  };

  const handleShowModal = () => {
    showBlured({
      title: "Ma'lumotlarni kiriting",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form fetch={fetchData} />,
    });
  };
  const handleUpdate = (data) => {
    showBlured({
      title: "Tahrirlash",
      maxWidth: "400px",
      height: "400px",
      withHeader: false,
      body: () => <Form fetch={fetchData} id={data?.id} />,
    });
  };

  if (loading) return <Spinner />;
  return (
    <Wrapper>
      <Header>
        <Tab
          tabs={options}
          defaultCurrent={selectedCategory}
          onChange={(key) => changeTab(key)}
        />
        <div className="xodim">
          <div className="title">
            Xodimlar soni: <span className="num">{data.length}</span>
          </div>
          <Button
            text="Qo'shish"
            icon={<PlusOutlined />}
            onClick={handleShowModal}
          />
        </div>
      </Header>
      <CardWrapper>
        {data.map((item) => {
          return (
            <OurTeamCard
              key={item.id}
              data={item}
              handleUpdate={handleUpdate}
              handleDelete={handleDelete}
            />
          );
        })}
      </CardWrapper>
      {total > 10 && (
        <Pagination
          total={total}
          onChange={handleChangePagination}
          defaultPageSize={pagination.limit}
          defaultCurrent={pagination.page}
        />
      )}
    </Wrapper>
  );
}

export default Dashboard;
